  const strap_select = document.getElementById("strap-design-select");
  const imageGroups = document.querySelectorAll(".strap-images");
  const strp_cat = document.getElementById("strp_cat");
  const strp_dsgn = document.getElementById("strp_dsgn");
  const strp_dsgn_image = document.getElementById("strp_dsgn_image");
 

  // Persistent variable for the selected variant
  let selectedVariantWithStrapValue = '';

  // Event listener to capture result from strap selection event
  window.addEventListener('strap-result-ready', (e) => {
    selectedVariantWithStrapValue = e.detail.result;
  });

  function updateFromSelectedImage() {
    
    const selectedImg = document.querySelector('.strap-images .splide__slide img.selected');
    //console.log('selectedImg ',selectedImg);
    if (!selectedImg) return;

    const currentValue = selectedImg.alt;

    
    let parts = selectedVariantWithStrapValue.split(' / ');
    parts[parts.length - 1] = currentValue;
    selectedVariantWithStrapValue = parts.join(' / ');

    getAndSetSlider(selectedVariantWithStrapValue)



  }


  initSplideCarousels()


  // Track strap Splide instances
const splideInstances = new Map();

function initStrapSplide(group) {
  if (splideInstances.has(group)) {
    // Already mounted — just refresh
    requestAnimationFrame(() => splideInstances.get(group).refresh());
    return;
  }

  try {
    const splide = new Splide(group, {
      type: 'slide',
      perPage: 3,
      pagination: false,
      arrows: true,
      gap: '1rem',
    });
    splide.mount();
    splideInstances.set(group, splide);
  } catch (err) {
    console.error("Error initializing strap Splide:", err);
  }
}



function updateImages() {
  const selectedValue = strap_select.value;

  imageGroups.forEach(group => {
    const groupValue = group.getAttribute("data-option");
    if (!groupValue) return;

    if (groupValue === selectedValue) {
      group.style.display = "block";

      // Use requestAnimationFrame to wait for layout
      requestAnimationFrame(() => {
        initStrapSplide(group); // mount or refresh the Splide

        const firstImg = group.querySelector("img");
        if (firstImg) {
          selectImage(firstImg);

          // Another frame to ensure Splide has fully rendered
          requestAnimationFrame(() => firstImg.click());
        }
      });

    } else {
      group.style.display = "none";
    }
  });

  if (strp_cat) strp_cat.value = selectedValue;
}



// Ensure default dropdown value on page load
if (!strap_select.value && strap_select.options.length > 0) {
  strap_select.value = strap_select.options[0].value;
}

  function selectImage(imgElement) {
    if (!imgElement) return;

    document.querySelectorAll(".strap-images img").forEach(img => {
      img.classList.remove("selected");
    });

    imgElement.classList.add("selected");

    if (strp_dsgn) strp_dsgn.value = imgElement.alt;
    if(strp_dsgn_image) strp_dsgn_image.value = imgElement.src;

  }


  document.addEventListener("click", function (e) {
    if (e.target.matches(".strap-images img")) {
      selectImage(e.target);
    }
  });

  
  strap_select.addEventListener("change", updateImages);
  


  //initSplides();
  updateImages();
  updateFromSelectedImage()
 



